module.exports = __webpack_public_path__ + "static/media/front.1014d2c1.svg";